import React, { useState, useRef, useEffect, useContext } from 'react';
import MusicPlayerContext from '../../context/MusicPlayerContext';
import axios from 'axios';
import playIcon from '../../../../assests/images/play.svg';
import pauseIcon from '../../../../assests/images/pause.svg';
import alertBox from '../../../../assests/images/alert_box.png';

export const PlayerComponent = (props: any) => {

  const { tracks, getSongData } = props;

  const track = useState(tracks);
  const video: any = useRef(null);
  const [loading, setLoading] = useState(true);
  const [data, setData]  = useState('');
  const [count, setCount] = useState(0);
  
  //@ts-ignore
  const { play, pause, isPlaying } = useContext(MusicPlayerContext);
  const [playing,setPlaying] = useState(false);
  const value = isPlaying(track[0].id)
  
  const API = `https://plugin-epidemic-api.ssemble.com`;

  useEffect(() => {
    const fetchData = async () =>{
     if(count === 0){
      setLoading(true);
      try {
        const response = await axios.get(`${API}/download?id=${track[0].id}`);
        setCount(1)
        if(data === ''){
          setData(response.data.file);
        }
      } catch (error) {
        //@ts-ignore
        console.log(error.message);
        const alterDiv: any = document.getElementById('alert_message');
          alterDiv.style.display = 'block'
            setTimeout(() => {
              alterDiv.style.display = 'none'
              window.location.reload();
            }, 1500)
      }
      setLoading(false);
     }
    }
    fetchData();
  }, [tracks, loading, data, count, track, API]);
  
  const handleClick = async (e : any) => {

    const duration = `${Math.floor(tracks.length/60)}:${Math.ceil(tracks.length%60)}`;

    const returnJson = {
      action:'create', 
      type:'mp3', 
      file:data,
      fileDuration: duration
    }
    getSongData(returnJson)
    //@ts-ignore
  if (window.vlogr) {
    //@ts-ignore
    window.vlogr.addData(1, JSON.stringify(returnJson));
  }
    //@ts-ignore
  if (window.webkit) {
    //@ts-ignore
    window.webkit.messageHandlers.addData.postMessage(returnJson);
  }
  if (window.top) {
    window.top.postMessage(returnJson, '*');
  }
  pause();
  setPlaying(false);
  }

  /*
  * Handling the state of play/pause icon and of video player 
  */
  const handleDivClick = (e: any) => {
    if(value === false && playing === false){
      play(e.target.id);
      isPlaying(e.target.id)
      setPlaying(true);
    }else{
      pause();
      setPlaying(false);
    }
  }

  useEffect(()=>{
    if(value){
      video.current.play();
    }else{
      video.current.pause();
    }
  })

  return (
      <div className='player-component' draggable>
        <div className='fl-left ml-left-10 info-box' id={track[0].id} onClick={handleDivClick}
        >
          <div className='fl-left' id={track[0].id}  >
            <div className='play-div' style={{ backgroundImage: `url(${tracks.images.default})` , backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}} id={track[0].id}>
                {value? (
                 <img className={''} src={pauseIcon} style={{ float: 'left', marginLeft: '11px', marginTop: '11px'}}  alt='PU' />
                  ) : (
                   <img  className={''} src={playIcon} style={{ float: 'left', marginLeft: '11px', marginTop: '11px' }}  alt='PL' id={track[0].id} />
                  )}
            </div>
            <div style={{ marginTop: '5px' }}>
              <div id='alert_message' style={{ width: '150px', height: '35px', alignItems: 'center', display: 'none', zIndex: 999, marginTop: '17.2em', marginLeft: '8em', position : 'absolute'}}>
                <span style={{ fontSize: '15px', fontWeight: '400', fontFamily: 'Inter', color: '#FFFFFF', marginTop: '7px', position: 'fixed', marginLeft: '30px' }}>Please try again</span>
                <img src={alertBox} width='151px' height='35px' alt='Alert box' />
              </div>
                  {/*@ts-ignore*/}
                <audio style={{ background:'#000000', borderRadius:'2px', width:'36px', height:'36px'}} ref={video} id="video" preload='metadata' autoload={'false'} poster={tracks.images.default} controls={false} muted={false} playsInline loop>
                  <source src={data} key={data} type="audio/mp3"/>
                </audio>
            </div>
          </div>
          <div className='ml-left-9 text-l-align truncate' id={track[0].id}>
            <span className='track-title' id={track[0].id}>{tracks.title}</span>
              <p className='track-sub-title' id={track[0].id}><div className='truncate-sub' style={{display:'inline-block', maxWidth:'149px' }} id={track[0].id}><span className='fl-left' id={track[0].id}>{tracks.mainArtists[0]}</span></div><span className='pl-5' id={track[0].id}>{Math.floor(tracks.length/60)}:{Math.ceil(tracks.length%60)}</span></p>
          </div>
        </div>
        <div className='fl-right'>
          <button className='add-button' onClick={handleClick}>Add</button>
        </div>
      </div>
  )
}